(() => {
  if (customElements.get('alicja-price-row')) return;

  class AlicjaPriceRow extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.ready = () => this.initialize();
      this.queue = () => {
        if (!this.isConnected || this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.measure();
        });
      };
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.ready, {once: true});
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (!this.isConnected || this.observer) return;
      this.context = document.createElement('canvas').getContext('2d');
      if (!this.context) return;
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(this, {childList: true, characterData: true, subtree: true});
      this.resize = new ResizeObserver(this.queue);
      this.resize.observe(this);
      window.addEventListener('resize', this.queue);
      document.fonts?.addEventListener('loadingdone', this.queue);
      document.fonts?.ready.then(this.queue);
      this.queue();
    }

    measure() {
      for (const box of this.querySelectorAll('.alicja-price__ink')) {
        this.resize?.observe(box);
        const text = box.querySelector('.alicja-price__text');
        if (!text || !text.textContent.trim()) continue;
        let baseline = text.querySelector('.alicja-price__baseline');
        if (!baseline) {
          baseline = document.createElement('span');
          baseline.className = 'alicja-price__baseline';
          baseline.setAttribute('aria-hidden', 'true');
          text.append(baseline);
        }
        // Measure the natural line box and its actual alphabetic baseline.
        box.style.removeProperty('--price-ink-trim-top');
        box.style.removeProperty('--price-ink-trim-bottom');
        const style = getComputedStyle(text);
        const fontSize = parseFloat(style.fontSize);
        if (!fontSize) continue;
        this.context.font = style.font || `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        this.context.textBaseline = 'alphabetic';
        const metrics = this.context.measureText(text.textContent.trim());
        const ascent = metrics.actualBoundingBoxAscent;
        const descent = metrics.actualBoundingBoxDescent;
        if (!Number.isFinite(ascent) || !Number.isFinite(descent) || ascent + descent <= 0) continue;
        const rect = text.getBoundingClientRect();
        const baselineOffset = baseline.getBoundingClientRect().top - rect.top;
        // Trim only the measured empty font space. Values scale with the font in em.
        const top = (baselineOffset - ascent) / fontSize;
        const bottom = (rect.height - baselineOffset - descent) / fontSize;
        box.style.setProperty('--price-ink-trim-top', `${top}em`);
        box.style.setProperty('--price-ink-trim-bottom', `${bottom}em`);
      }
      this.setAttribute('data-price-centered', '');
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.ready);
      window.removeEventListener('resize', this.queue);
      document.fonts?.removeEventListener('loadingdone', this.queue);
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.observer = null;
      this.resize = null;
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }

  customElements.define('alicja-price-row', AlicjaPriceRow);
})();
